import type { FieldValidationInput, ValidationError } from '../../../../types/validation.tsx';
import { composeValidators } from '../utils.tsx';
import { validateMultilineFieldDefaultValue } from './multi-line-text/index.tsx';
import { validateNumberFieldDefaultValue } from './number/index.tsx';
import { validateTextFieldDefaultValue } from './single-line-text/index.tsx';

const validators = composeValidators([
	validateNumberFieldDefaultValue,
	validateTextFieldDefaultValue,
	validateMultilineFieldDefaultValue,
]);

export const fieldDefaultValueValidator = (
	input: FieldValidationInput,
): ReadonlyArray<ValidationError> => validators(input);
